<template>
  <div class="operator-step-five_block">
    <div class="left">
      <h3 class="large_blue_label">5. 納品・検収</h3>
      <p>作業中に生じた疑問点はそのままにせず、積極的にクライアントへ質問することをお勧めします。フルーが提供するメッセージフォームを利用するか、電話や外部のビデオ会議ツール等をご利用ください。</p>
      <br>
      <p class="marker-underline_label">作業が完了しましたら、成果品をアップロード頂きます。</p>
      <p>フルーのシステム内にファイル送受信フォームがありますので、そちらをご利用ください。</p>
      <br>
      <p class="marker-underline_label">成果品のアップロード後は必ず「納品完了・検査を依頼する」ボタンを押下してください。</p>
      <p>「納品完了・検査を依頼する」ボタンを押さないと、クライアントへ検査依頼が出されません。</p>
      <br>
      <p class="marker-underline_label">クライアントの検査の結果、検収されれば業務は終了となります。</p>
      <p>この時、仮決済でフルーが預かっている契約金から所定の手数料を差し引いた金額がオペレーターのアカウントへ送金されます。</p>
      <br>
      <p>クライアントの検査の結果、不合格の場合はクライアントと連絡を取り、不具合内容や対処法について確認をお願いします。対処法につきましては基本的に契約時にクライアントと交わした対処法（作業時間払いで業務終了とするか、是正処置をするか等）によることとします。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/op_five_steps_5.png'>
    </div>
  </div>
</template>

<script>
export default {
  name: "OperatorStepFiveBlock"
}
</script>

<style lang="scss" scoped>
.operator-step-five_block {
  @include double_columns(40%, 35%);

  .marker-underline_label {
    margin-top: 2rem;
  }

  @media screen and (max-width: 767px) {
    > .right > .base_image {
      margin: 2rem auto 0 auto;
    }
  }
}
</style>